import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export interface IConfiguracaoPdv {
  idconfiguracaopdv: string;
  // Conta bancária padrão pra onde entradas de PIX/transferência do PDV são
  // roteadas (ver ConfiguracaoPdv.ts no backend) — opcional, nem todo tenant
  // configura.
  idcontapadraopix?: string;
  contapadraopixTitular?: string;
  tipoimpressao: 'termica' | 'a4' | 'matricial' | 'naoimprimir';
  tipopesquisa: 'nome' | 'codigo' | 'codigobarras' | 'todos';
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

// Singleton por tenant (uma linha só, sem id/empresa no path) — mesmo padrão
// de /empresa.
const get = async (): Promise<IConfiguracaoPdv | Error> => {
  try {
    const { data } = await Api.get('/configuracaopdv');
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar a configuração do PDV.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    }
    return new Error('Erro inesperado');
  }
};

export const ConfiguracaoPdvService = {
  get,
};
